import { render, staticRenderFns } from "./PatientHistorySearch.vue?vue&type=template&id=792ec161"
import script from "./PatientHistorySearch.vue?vue&type=script&lang=js"
export * from "./PatientHistorySearch.vue?vue&type=script&lang=js"
import style0 from "./PatientHistorySearch.vue?vue&type=style&index=0&id=792ec161&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports